/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllEditionsResponse } from '../../models/get-all-editions-response';

export interface AdminServiceGetAllEditions$Params {
}

export function adminServiceGetAllEditions(http: HttpClient, rootUrl: string, params?: AdminServiceGetAllEditions$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllEditionsResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceGetAllEditions.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllEditionsResponse>;
    })
  );
}

adminServiceGetAllEditions.PATH = '/api/v3/gateway/admin/edition';
